/**
 * Audiometry Service (#461)
 * Limiares, referência e histórico audiométrico.
 */

import apiClient from './apiClient';
import type {
  AudiometryHistory,
  AudiometryRecord,
  SaveAudiometryData,
} from '../types/audiometry';

class AudiometryService {
  private getExamUrl(appointmentId: number, examId: number): string {
    return `/appointments/${appointmentId}/exams/${examId}/audiometry`;
  }

  async saveThresholds(
    appointmentId: number,
    examId: number,
    data: SaveAudiometryData,
  ): Promise<AudiometryRecord> {
    const response = await apiClient.put(this.getExamUrl(appointmentId, examId), data);
    return response.data?.data ?? response.data;
  }

  async setAsReference(appointmentId: number, examId: number): Promise<AudiometryRecord> {
    const response = await apiClient.put(`${this.getExamUrl(appointmentId, examId)}/reference`);
    return response.data?.data ?? response.data;
  }

  async getHistory(employeeId: number): Promise<AudiometryHistory> {
    const response = await apiClient.get(`/employees/${employeeId}/audiometry`);
    return response.data?.data ?? response.data;
  }
}

export const audiometryService = new AudiometryService();
export default audiometryService;
